import { atom } from "jotai";

export const lastViewedTripIdAtom = atom<string | null>(null);
